import GiftsApi from '@/lib/api/Gifts'
import { filterRemoveAlreadyAddedGiftsFromCatalog } from '@/components/Gift/GiftListUtils'

export default {
  namespaced: true,

  state: {
    tab: 'editar-lista',
    isEditing: false,
    tabContainerScrollLeft: 0,
    giftsList: [],
    giftsListAmount: '',
    giftsListCategories: [],
    giftsFromCatalog: [],
    storesExternal: [],
    saving: false,
    hasMassEditFeature: false,
  },

  mutations: {
    SET_GIFTS_LIST(state, payload) {
      state.giftsList = payload
    },
    SET_GIFTS_LIST_AMOUNT(state, payload) {
      state.giftsListAmount = payload
    },
    SET_GIFTS_LIST_CATEGORIES(state, payload) {
      state.giftsListCategories = payload
    },
    SET_GIFTS_FROM_CATALOG(state, payload) {
      state.giftsFromCatalog = payload
    },
    SET_GIFTS_TAB(state, payload) {
      state.tab = payload
    },
    SET_STORES_EXTERNAL(state, payload) {
      state.storesExternal = payload
    },
    SET_SAVING(state, payload) {
      state.saving = payload
    },
    SET_TAB_CONTAINER_SCROLL_LEFT(state, payload) {
      state.tabContainerScrollLeft = payload
    },
    SET_IS_EDITING(state, payload) {
      state.isEditing = payload
    },
    SET_HAS_MASS_EDIT_FEATURE(state, payload) {
      state.hasMassEditFeature = payload
    },
  },

  actions: {
    async fetchGiftsList({ dispatch, commit, rootState }) {
      const logonToken = rootState.app.logonToken
      const api = new GiftsApi(logonToken)

      const { data } = await api.getGiftsList()

      if (data) {
        commit('SET_GIFTS_LIST', data.list)
        commit('SET_GIFTS_LIST_AMOUNT', data.total_amount)

        const hasMassEditFeature = data.max_discount_percentage !== undefined && 
                                   data.lowest_gift_value !== undefined && 
                                   data.total_amount_with_max_discount !== undefined;
                                   
        commit('SET_HAS_MASS_EDIT_FEATURE', hasMassEditFeature)
        
        await dispatch('gifts/fetchGiftsListCategories', '', { root: true })
      }
    },

    async fetchGiftsListCategories({ commit, getters, rootState }) {
      const logonToken = rootState.app.logonToken
      const api = new GiftsApi(logonToken)

      const { data } = await api.getGiftsCategories()

      if (data) {
        commit('SET_GIFTS_LIST_CATEGORIES', data)
      }
    },

    async fetchGiftsFromCatalog({ dispatch, getters, rootState }) {
      const logonToken = rootState.app.logonToken
      const api = new GiftsApi(logonToken)

      const { data } = await api.getGiftsFromCatalog()

      if (data) dispatch('gifts/setGiftsFromCatalog', data, { root: true })
    },

    setGiftsFromCatalog({ commit }, payload) {
      commit('SET_GIFTS_FROM_CATALOG', payload)
    },

    setGiftsList(context, payload) {
      context.commit('SET_GIFTS_LIST', payload)
    },

    setGiftsTab(context, payload) {
      context.commit('SET_GIFTS_TAB', payload)
    },

    setStoresExternal(context, payload) {
      context.commit('SET_STORES_EXTERNAL', payload)
    },

    setSaving(context, payload) {
      context.commit('SET_SAVING', payload)
    },
    setTabContainerScrollLeft(context, payload) {
      context.commit('SET_TAB_CONTAINER_SCROLL_LEFT', payload)
    },

    setIsEditing(context, payload) {
      context.commit('SET_IS_EDITING', payload)
    },
  },

  getters: {
    getGiftsList(state) {
      return state.giftsList
    },
    getIsEditing(state) {
      return state.isEditing
    },
    getGiftsListAmount(state) {
      return state.giftsListAmount
    },
    getGiftsListCategories(state) {
      return state.giftsListCategories
    },
    getGiftsFromCatalog(state) {
      return filterRemoveAlreadyAddedGiftsFromCatalog(
        state.giftsList,
        state.giftsFromCatalog
      )
    },
    getHasMassEditFeature(state) {
      return state.hasMassEditFeature
    },
  },
}